export enum JobTypesWithRequirements {
  "DREXT", // Blocked Drain - External
  "DRINT", // Blocked Drain - Internal
  "EEALI", // Install An Electrical Appliance
  "EECLR", // Repair Or Replace A Light 3 Or More
  "EECLW", // Repair Or Replace A Light
  "EEFBI", // Install A Fusebox
  "EEFBW", // Repair A Fusebox
  "EELSR", // Repair Or Replace A Switch 3 Or More
  "EELSW", // Repair Or Replace A Switch
  "EERWI", // Rewire A Property
  "EESHR", // No Power To An Electrical Appliance
  "EESHW", // Repair Or Replace Extractor Fan
  "EESKW", // Repair Or Replace Socket
  "EESOW", // Repair Or Replace Socket 3 Or More
  "EEVIN", // (Install an EV Charger)
  "EEVRE", // (Repair an EV Charger)
  "EEXXX", // Loss Of Power In Property
  "ELSRP", // Electrical Condition Report
  "FPTPO", // Install a Garden Tap (FP)
  "FPTPT", // Install 2 Garden Taps (FP)
  "HBAHP", // Air Source Heat Pump Breakdown
  "HBGAS", // Gas Boiler Breakdown
  "HBSAS", // Back Boiler Service
  "HBSCP", // Cp12 With Boiler Service
  "HBSEP", // Boiler Service - Efficiency Package
  "HBSMK", // Gas Boiler Service (Marketing Offer)
  "HBSSP", // Gas Boiler Service - Safety Package
  "HCERT", // Cp12 (Boiler Only)
  "HCFCB", // Cp12 (Fire Cooker And Boiler)
  "HCFCO", // Cp12 (Fire And Cooker Only)
  "HCPBC", // Cp12 (Boiler And Cooker Only)
  "HCPBF", // Cp12 (Boiler And Fire Only)
  "HCPCO", // Cp12 (Cooker Only)
  "HCPFO", // Cp12 (Fire Only)
  "HIAHP", // Air Source Heat Pump Installation
  "HIGAS", // Install Gas Boiler
  "HIHOB", // Install Gas Cooker
  "HIHOR", // Install New Gas Run
  "HISMT", // Repair Or Replace A Boiler Thermostat
  "HIWTR", // Install Water Heater
  "HLBDW", // LPG Boiler Breakdown
  "HLERT", // LPG Cp12 (Boiler Only)
  "HLFCB", // LPG Cp12 (Fire Cooker And Boiler)
  "HLFCO", // LPG Cp12 (Fire And Cooker Only)
  "HLFIR", // LPG Fire Service
  "HLGAS", // Install LPG Boiler
  "HLHOB", // Install LPG Cooker
  "HLLEK", // LPG Leak
  "HLPBC", // LPG Cp12 (Boiler And Cooker Only)
  "HLPBF", // LPG Cp12 (Boiler And Fire Only)
  "HLPCO", // LPG Cp12 (Cooker Only)
  "HLPFO", // LPG Cp12 (Fire Only)
  "HLSAS", // LPG Back Boiler Service
  "HLSCP", // LPG Cp12 With Boiler Service
  "HLSMK", // LPG Boiler Service (Marketing Offer)
  "HLSMT", // Repair Or Replace A LPG Boiler Thermostat
  "HLSRV", // LPG Boiler Service
  "HLTAT", // Repair an LPG Fire
  "HLWTR", // Install an LPG Water Heater
  "HRLEK", // Gas Leak
  "HSAHP", // Air Source Heat Pump Service
  "HSFIR", // Gas Fire Service
  "HSGAS", // Gas Boiler Service
  "HSTAT", // Repair A Gas Fire
  "HSWBR", // Pre Winter Offer – Boiler Service & Radiator Bleed
  "LREPA", // Repair Lock
  "LREPL", // Replace Lock
  "LRGAI", // Gain Access
  "LRGAZ", // Gain Access To A Upvc Door
  "LRGCL", // Gain Access To A Wooden Door
  "LRGML", // Gain Access Other
  "LRPCL", // Replace A Lock On A Upvc Door
  "LRPGD", // Replace A Lock On A Garage Door
  "LRPMD", // Replace A Lock Other
  "LRPML", // Replace A Lock On A Wooden Door
  "PDCDW", // Disconnect An Appliance
  "PIBSN", // Install Bathroom Fixture (Bath/Toilet/Sink)
  "PICYL", // Install Water Cylinder
  "PIPMP", // Repair Or Replace A Pump
  "PISHW", // Install Thermostatic Shower
  "PITNK", // Install Water Tank
  "PIUCY", // Install Unvented Water Cylinder
  "PLBTH", // Leaking Bath
  "PLCYL", // Water Cylinder/Immersion Tank
  "PLFRO", // Frozen Pipe
  "PLINR", // Install Radiators 3 Or More
  "PLOVF", // Leaking Overflow Pipe
  "PLPIP", // Leaking Pipe Exposed
  "PLPIS", // Leaking Pipe Hidden
  "PLRAD", // Leaking Radiator
  "PLSIC", // Installation of a customer-supplied shower
  "PLSLP", // Repair or Replace Shower
  "PLSNL", // Leaking Sink
  "PLSRP", // Repair of a Shower
  "PLSRT", // Replacement of a Shower - 8.5KW White
  "PLSTK", // Repair Or Replace A Stop Cock
  "PLSTP", // Replace Pipework
  "PLTFF", // Toilet Not Flushing
  "PLTFP", // [FIXED PRICE £99] Toilet Not Flushing
  "PLTIC", // Fitting of a customer-supplied internal tap
  "PLTLT", // Leaking Toilet
  "PLTNK", // Leaking Cold Water Tank
  "PLTRP", // Repair of an internal tap
  "PLTRT", // Replacement of a standard internal tap
  "PLWKE", // Install Fresh Pipe Work
  "PTOTH", // Repair Or Replace An Outside Tap
  "PWFLS", // Power Flush
  "SDSTV", // Perform A Cctv Survey Of A Drain
  "SPIDW", // Connect An Appliance
  "SPRBB", // Repair Or Replace A Tap
}

export type InputTypes = "radio" | "checkbox" | "message" | "text";

export interface JobTypesAnswer {
  text: string;
  value: string;
}

export interface JobTypesOption {
  name: string;
  question: string;
  answers?: Array<JobTypesAnswer>;
  type: InputTypes;
  depends: null | number;
  trigger?: string; // if trigger is set, then the question will only be asked if the answer to the depends question is equal to the trigger value otherwise it will be only show if it matches "true"
  altJobTypes?: string[]; // if altJobTypes is set, then the question will only be asked if the answer to the depends question is equal to the trigger value otherwise it will be only show if it matches "true"
}

export type JobTypesOptions = {
  [key: string]: Array<JobTypesOption>;
};

export const jobTypesWithRequirements = Object.keys(JobTypesWithRequirements);
